import { c as _c } from "react/compiler-runtime";
import { SelectProjectRole } from "@components/role/select-project-role";
import { MemberRoleReadOnly } from "@components/table/members/members-column/role-column/member-role-read-only";
import { useHasUserValidPermissionProjectLevel } from "@hooks/permission-control/use-has-user-valid-permission-project-level";
import { useChangeMemberRole } from "@hooks/use-change-member-role";
import { isSelectedProjectEditableSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { currentUserSelector } from "@store/user/user-selector";
import { DEFAULT_TEXT_FONT_SIZE } from "@styles/common-styles";
import { isProjectAdminSelfDowngrade } from "@utils/access-control/project-role-change-guard";
import { formatUserRoleType } from "@utils/data-display";
/** Render and adjust member roles in project context. */
export function ProjectMemberRole(t0) {
  const $ = _c(21);
  const {
    companyId,
    projectId,
    memberIdentityRole,
    isReadOnly: t1,
    location
  } = t0;
  const isReadOnly = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = isSelectedProjectEditableSelector();
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const isProjectEditable = useAppSelector(t2);
  const currentUser = useAppSelector(currentUserSelector);
  const {
    canChangeRole
  } = useHasUserValidPermissionProjectLevel();
  let t3;
  if ($[1] !== projectId) {
    t3 = {
      id: projectId
    };
    $[1] = projectId;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = t3;
  let t5;
  if ($[3] !== companyId || $[4] !== location || $[5] !== memberIdentityRole.identity || $[6] !== memberIdentityRole.role || $[7] !== t4) {
    t5 = {
      companyId,
      location,
      subjectType: "project",
      memberIdentity: memberIdentityRole.identity,
      currentRole: memberIdentityRole.role,
      selectedProject: t4
    };
    $[3] = companyId;
    $[4] = location;
    $[5] = memberIdentityRole.identity;
    $[6] = memberIdentityRole.role;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const {
    changeMemberRole
  } = useChangeMemberRole(t5);
  const shouldHideDropdown = getShouldHideDropdown();
  function getShouldHideDropdown() {
    const isResourceOwner = memberIdentityRole.role === "RESOURCE_OWNER";
    const isSelfRoleChangeRestricted = isProjectAdminSelfDowngrade({
      currentUser,
      memberIdentity: memberIdentityRole.identity,
      memberProjectRole: memberIdentityRole.role
    });
    return !isProjectEditable || !canChangeRole || isResourceOwner || isSelfRoleChangeRestricted;
  }
  if (isReadOnly) {
    let t6;
    if ($[9] !== memberIdentityRole.role) {
      t6 = <MemberRoleReadOnly role={memberIdentityRole.role} variant="borderless" />;
      $[9] = memberIdentityRole.role;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  if (shouldHideDropdown) {
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        fontSize: DEFAULT_TEXT_FONT_SIZE
      };
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    let t7;
    if ($[12] !== memberIdentityRole.role) {
      t7 = formatUserRoleType(memberIdentityRole.role);
      $[12] = memberIdentityRole.role;
      $[13] = t7;
    } else {
      t7 = $[13];
    }
    let t8;
    if ($[14] !== t7) {
      t8 = <span style={t6}>{t7}</span>;
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    return t8;
  }
  let t6;
  if ($[16] !== changeMemberRole) {
    t6 = async function onRoleChange(role) {
      try {
        await changeMemberRole(role);
      } catch {}
    };
    $[16] = changeMemberRole;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const onRoleChange = t6;
  const t7 = memberIdentityRole.role;
  let t8;
  if ($[18] !== onRoleChange || $[19] !== t7) {
    t8 = <SelectProjectRole selectedRole={t7} onChange={onRoleChange} variant="borderless" />;
    $[18] = onRoleChange;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}